import React, { useEffect, useRef } from 'react';
import cx from 'classnames';
import { useHistory } from 'react-router-dom';

import { ReactComponent as ConfirmIcon } from 'assets/icons/confirm.svg';
import DentalButton from 'components/Buttons/DentalButton/DentalButton';
import LoadingScreen from 'components/LoadingScreen/LoadingScreen';

import styles from './BookingConfirmation.module.scss';

import Message from '../Message/Message';
import useIsLoadedInsideIframe from 'hooks/useIsLoadedInsideIframe';
import useNotifyBookingCompleted from 'hooks/useNotifyBookingCompleted';
import { useAppDispatch } from 'redux/reduxHooks';
import { resetTempAccessToken } from 'redux/authSlice';

interface IProps {
  isMessageDisplayed?: boolean;
  isSocialLoggedIn?: boolean;
}

const BookingConfirmation = ({
  isMessageDisplayed,
  isSocialLoggedIn,
}: IProps) => {
  const history = useHistory();

  const dispatch = useAppDispatch();

  const containerRef = useRef<HTMLDivElement>(null);
  const isLoadedInsideIframe = useIsLoadedInsideIframe();

  const { isRedirectEnabled, onBookingCompleted } =
    useNotifyBookingCompleted();

  useEffect(() => {
    onBookingCompleted();
  }, [onBookingCompleted]);

  const containerClassName = cx({
    [styles['container']]: true,
    [styles['container-iframe']]: isLoadedInsideIframe,
  });

  const onDoneClick = () => {
    dispatch(resetTempAccessToken());
    history.go(0);
  };

  if (isRedirectEnabled) {
    return <LoadingScreen message="Redirecting..." />;
  }

  return (
    <div className={containerClassName} ref={containerRef}>
      <div className={styles.wrapper}>
        <ConfirmIcon />
        <div className={styles.title}>Appointment Request Submitted</div>
        <p className={styles.description}>
          Your request was successfully submitted. The practice will get back to
          you shortly to confirm.
        </p>
        {isMessageDisplayed && (
          <Message
            type={isSocialLoggedIn ? 'success' : 'warning'}
            message={
              isSocialLoggedIn
                ? 'Your FirstIn account has been set up successfully.'
                : 'Further action is required for FirstIn account registration. Please click the link in the verification email to complete setting up your account.'
            }
          />
        )}
        {!isLoadedInsideIframe && (
          <DentalButton
            variant="contained"
            className={styles['btn']}
            onClick={onDoneClick}
          >
            Done
          </DentalButton>
        )}
      </div>

      <div></div>
    </div>
  );
};

export default BookingConfirmation;
